const DMapProps = {
  center: [37.874641, 32.493156],
  zoom: 13,
  zoomControl: false,
  scrollWheelZoom: true,
};
const DTileLayerProps = {
  // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
};
const DZoomLayerProps = {
  position: 'bottomright',
  zoomInText: '+',
  zoomOutText: '-',
  zoomInTitle: 'Zoom in',
  zoomOutTitle: 'Zoom out',
};

const markers = [
  {
    items: [
      {
        satellites: 0,
        localDateTime: '2023-11-07T13:22:00Z',
        engineOn: true,
        distance: 0,
        vehiclePlate: '42C1306',
        latitude: 37.9564087,
        deviceKey: '3091070',
        speed: -4,
        mtId: '0E4NSTV0XYS8S',
        engineHours: 0,
        mCode: 'KV',
        totalDistance: 0,
        longitude: 32.5903961,
      },
    ],
    tooltip: {
      content: <Constants />,
      props: {
        direction: 'bottom',
        offset: [0, 20],
        opacity: 1,
        permanent: false,
      },
    },

    icon: function (item) {
      return divIcons.car(item);
    },
    position: function (item) {
      return locToLangLong(item);
    },
    eventhandlers: {
      click: (event, item) => {
        console.log('clickEvent', event, item);
      },
    },
  },
  {
    items: [
      {
        satellites: 0,
        localDateTime: '2023-11-07T13:22:00Z',
        engineOn: true,
        distance: 0,
        vehiclePlate: '42C1306',
        latitude: 37.9567187,
        deviceKey: '3091070',
        speed: -4,
        mtId: '0E4NSTV0XYS8S',
        engineHours: 0,
        mCode: 'KV',
        totalDistance: 0,
        longitude: 32.5903961,
      },
    ],
    popup: {
      content: <Constants />,
      props: {
        offset: [0, -100],
        opacity: 1,
      },
    },

    icon: function (item) {
      return divIcons.car(item);
    },
    position: function (item) {
      return locToLangLong(item);
    },
    eventhandlers: {
      click: (event, item) => {
        console.log('clickEvent', event, item);
      },
    },
  },
  {
    items: [
      {
        satellites: 0,
        localDateTime: '2023-11-07T13:22:00Z',
        engineOn: true,
        distance: 0,
        vehiclePlate: '42C1306',
        latitude: 37.9570187,
        deviceKey: '3091070',
        speed: -4,
        mtId: '0E4NSTV0XYS8S',
        engineHours: 0,
        mCode: 'KV',
        totalDistance: 0,
        longitude: 32.5903961,
      },
    ],
    icon: function (item) {
      return divIcons.car(item);
    },
    position: function (item) {
      return locToLangLong(item);
    },

    eventhandlers: {
      click: (event, item) => {
        console.log('clickEvent', event, item);
      },
    },
  },
];

export default function Constants() {
  return <div>constants</div>;
}

export { DMapProps, DTileLayerProps, DZoomLayerProps, markers };
